import { axiosBasic, axiosBearer } from "../config/axios-common";
import MedicalTeam from "../models/MedicalTeam";


const postInsertOrUpdateMedicalTeam = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/medicalTeam/insertOrUpdateMedicalTeam?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};

const CreateAndGetMedicalTeamFromTasy = async (requestId: string): Promise<MedicalTeam[]> => {

    const response = await axiosBearer.post(`/sam/v1/medicalTeam/CreateAndGetMedicalTeamFromTasy?requestId=${encodeURIComponent(requestId)}`, {}).then(response => {

        var result = new Array<MedicalTeam>();

        if (response.data !== undefined && response.data.length > 0) {

            result = response.data.map((row: any) => {
                let item = MedicalTeam.NewInstance();

                item.Id = row.id;
                item.NrCrm = row.nrCrm;
                item.Acronym = row.acronym;
                item.Name = row.name;
                item.PhysicalPersonTasyCode = row.physicalPersonTasyCode;
                item.OccupationTasyCode = row.occupationTasyCode;
                item.OccupationName = row.occupationName;
                item.TasyCode = row.tasyCode;
                item.RemoveTasy = row.removeTasy;

                return item;
            });
        }

        return result;
    })

    const responseData = await response;

    return responseData;

};


const getMyTeams = (): Promise<string[]> => {

    try {

        return axiosBearer.get(`/sam/v1/medicalTeam/getMyTeams`).then(response => {
            return response.data;
        }).catch(e => {
            console.log(e)
        });

    } catch (e: any) {
        throw e;
    }
};





const exportedObject = {
    getMyTeams,
    postInsertOrUpdateMedicalTeam,
    CreateAndGetMedicalTeamFromTasy,
};


export default exportedObject